<div class="PGSocial">
    <div class="row">
        @for (item of socialList; track item) {
            <div class="col-12 col-lg-6 pb-2">
                <div class="input-group">
                    <div class="input-group-text p-2">
                        <i class="fa-brands fa-fw fa-lg fa-{{item}}"></i>
                    </div>
                    <input class="form-control" [readonly]="readonly" [(ngModel)]="value[item]" (ngModelChange)="onValueChange()" placeholder="{{ 'pg-social.' + item | locTranslate }}">
                </div>
            </div>
        }
    </div>
</div>